import {
    NineSlicePlane
} from 'pixi.js';
import { LoadContext } from '../../utils';

const FRAME_WIDTH = 5;

export class UIBoxBG extends NineSlicePlane
{
    public static preload()
    {
        const loader = LoadContext.current;
        loader.add('SharedUI', './assets/shared/SharedUI{size}.json');
    }

    constructor(width: number, height: number)
    {
        const loader = LoadContext.current;
        super(loader.getSpritesheet('SharedUI').textures['ui_box_bg'], FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH, FRAME_WIDTH);
        this.width = width;
        this.height = height;
    }
}